<template>
  <div class="bilingual-content-tabs" lang="zh-TW">
    <div role="tablist" aria-label="內容編輯語系" class="content-tabs">
      <button type="button" role="tab" :aria-selected="tab === 'zh'" @click="tab = 'zh'" data-testid="content-tab-zh">中文內容</button>
      <button type="button" role="tab" :aria-selected="tab === 'en'" @click="tab = 'en'" data-testid="content-tab-en">英文內容</button>
    </div>
    <div v-show="tab === 'zh'" role="tabpanel"><slot /></div>
    <div v-show="tab === 'en'" role="tabpanel">
      <TranslationEditor ref="translation" :resource-type="resourceType" :resource-id="resourceId" :source-revision="sourceRevision" />
    </div>
  </div>
</template>
<script setup>
/* global defineProps, defineExpose */
import { ref } from 'vue';
import TranslationEditor from './TranslationEditor.vue';
defineProps({ resourceType: { type: String, required: true }, resourceId: [Number, String], sourceRevision: { type: Number, default: 0 } });
const tab = ref('zh');
const translation = ref(null);
defineExpose({ confirmDiscard: () => !translation.value || translation.value.confirmDiscard() });
</script>
<style scoped>
.content-tabs { display: flex; gap: 8px; margin: 16px 0; }.content-tabs button { cursor: pointer; border: 1px solid #777; background: #272733; color: #eee; border-radius: 4px; padding: 12px 22px; }.content-tabs button[aria-selected="true"] { color: #12121b; background: #8be9fd; }
</style>
